var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'introduction-list',
  created () {
    if (sessionStorage.getItem('introduction_search_key')) {
      let search_key = JSON.parse(sessionStorage.getItem('introduction_search_key'))
      this.startDate = search_key.start_date ? new Date(search_key.start_date) : ''
      this.endDate = search_key.end_date ? new Date(search_key.end_date) : ''
      this.shopName = search_key.shop_name
      this.workStyle = search_key.work_style
      this.friendName = search_key.friend_name
      this.isComplete = search_key.is_complete
    }
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      introductions: [],
      startDate: '',
      endDate: '',
      shopName: '',
      workStyle: '',
      friendName: '',
      isComplete: '0'
    }
  },
  computed: {
    start_date: function() {
      if (this.startDate) {
        return this.startDate.getFullYear() + '-' + ("0" + (this.startDate.getMonth() + 1)).slice(-2) + '-' + ("0" + this.startDate.getDate()).slice(-2)
      } else {
        return ''
      }
    },
    end_date: function() {
      if (this.endDate) {
        return this.endDate.getFullYear() + '-' + ("0" + (this.endDate.getMonth() + 1)).slice(-2) + '-' + ("0" + this.endDate.getDate()).slice(-2)
      } else {
        return ''
      }
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      let data = {
        start_date: this.start_date,
        end_date: this.end_date,
        shop_name: this.shopName,
        work_style: this.workStyle,
        friend_name: this.friendName,
        is_complete: this.isComplete
      }
      sessionStorage['introduction_search_key'] = JSON.stringify(data)
      this.$store
        .dispatch('GET_INTRODUCTION_LIST', { data: data })
        .then(res => {
          this.introductions = res.data
          this.searchCallbackFlag = true
        })
        .catch(err => console.log(err))
    },
    goIntroductionDetail: function(introductionId) {
      this.$router.push({ path: '/introduction/' + introductionId })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/introduction-list.js